import { render, staticRenderFns } from "./place-group-by-type.vue?vue&type=template&id=3566094f&scoped=true"
import script from "./place-group-by-type.vue?vue&type=script&lang=js"
export * from "./place-group-by-type.vue?vue&type=script&lang=js"
import style0 from "./place-group-by-type.vue?vue&type=style&index=0&id=3566094f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566094f",
  null
  
)

export default component.exports